import { HttpResponse } from "@dirootie-core/http-types";
import { UserProfile } from "@dirootie-domain/iam";
import { application } from "../../../_runtime/bootstrap";
import { ActionButton } from "../../../components-common/buttons/ActionButton";
import { useState } from "react";
import { CustomInput, Loader, Modal, Table } from "taltech-styleguide";
import { useModal } from "@components-common/modals";
import { useLocation } from "react-router-dom";
import { useQuery } from "react-query";
import { useNotifications } from "@hooks";

export const AddUserToCourse = () => {
  const userNotifications = useNotifications();
  const guidRegex = /[\da-zA-Z]{8}-([\da-zA-Z]{4}-){3}[\da-zA-Z]{12}/g;
  const { pathname } = useLocation();
  let courseId = "";
  if (pathname.match(guidRegex)) {
    courseId = pathname.match(guidRegex)![0];
  }
  const { hideModal } = useModal();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [selectedUsers, setSelectedUsers] = useState<string[]>([]);
  const { data: users, isFetching } = useQuery(
    `selectedStudents&${searchTerm}`,
    () => {
      return application
        .getHttpClient()
        .get(
          `/coursesms/members/invitations?CourseId=${courseId}&displayName=${searchTerm}`
        )
        .then((x: HttpResponse) => {
          return x.body.items;
        });
    },
    {
      refetchOnWindowFocus: false,
    }
  );

  const AddSelectedUsers = () => {
    if (selectedUsers.length === 0) {
      userNotifications.error({ title: "Please select at least one student" });
      return;
    }
    setIsLoading(true);
    selectedUsers.forEach((studentId: string, index: number) => {
      const newStudent = {
        courseId: courseId,
        userId: studentId,
        state: "ACTIVE",
        role: users.find((x: UserProfile) => x.id === studentId)!.role,
      };

      application
        .getHttpClient()
        .post(`/coursesms/members`, newStudent)
        .then((x: HttpResponse) => {
          if (x.statusCode === 200) {
          }
          if (index === selectedUsers.length - 1) {
            setIsLoading(false);
            const newEvent = new CustomEvent("refetchTable");
            document.dispatchEvent(newEvent);
            hideModal();
          }
        });
    });
  };

  return (
    <>
      <Modal.Header closeButton={false}>Add user to course</Modal.Header>
      <Modal.Body>
        <div className="w-100" style={{ height: "500px" }}>
          <div className="tt-input__control mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Search for user"
              onInput={(e: any) => {
                if (e.target.value.length >= 3) {
                  setSearchTerm(e.target.value);
                } else {
                  setSearchTerm("");
                }
              }}
            />
          </div>
          {isLoading || isFetching ? (
            <div className="h-100 w-100 d-flex align-items-center justify-content-center">
              <Loader overlay />
            </div>
          ) : (
            <div style={{ maxHeight: "439px" }} className="overflow-auto">
              <Table>
                <thead>
                  <tr>
                    <th></th>
                    <th>Full Name</th>
                    <th>Role</th>
                    <th>Email</th>
                  </tr>
                </thead>
                <tbody>
                  {users.map((user: UserProfile) => (
                    <tr key={user.id}>
                      <td style={{ minWidth: "unset", maxWidth: "25px" }}>
                        <CustomInput
                          type="checkbox"
                          checked={selectedUsers.includes(user.id)}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setSelectedUsers([...selectedUsers, user.id]);
                            } else {
                              setSelectedUsers(
                                selectedUsers.filter(
                                  (id: string) => id !== user.id
                                )
                              );
                            }
                          }}
                        />
                      </td>
                      <td>{user.displayName}</td>
                      <td>{user.role}</td>
                      <td>{user.email}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer className="justify-content-between border-top">
        <ActionButton kind="close" onAction={hideModal} />
        <ActionButton
          kind="add"
          isLoading={isLoading}
          onAction={AddSelectedUsers}
        />
      </Modal.Footer>
    </>
  );
};
